// extracted by mini-css-extract-plugin
export default {"statsSection":"StatsSection_statsSection__FQVsP","container":"StatsSection_container__3A-7S","stat":"StatsSection_stat__Y6ZYN"};